<template>
  <div style="height: calc(100vh - 12vh);padding:0 1vw">
    <div class="breadcrumb title-crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>采购审核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="header">
        <div :class="[{purchase: true}, {active: type == 1}]" @click="switchType(1)">待审核</div>
        <div :class="[{purchase: true}, {active: type == 2}]" @click="switchType(2)">已审核</div>
      </div>
      <div class="search">
        <el-form :inline="true" style="text-align: left;">
          <el-form-item label="采购名称：">
            <el-input v-model="search.orderName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="申请人：">
            <el-input v-model="search.brand" placeholder="请输入"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="select">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table :data="tableData" border style="width: 100%" height="60vh">
        <el-table-column prop="date" label="序号" type="index" :index="indexMethod" width="80">
        </el-table-column>
        <el-table-column prop="date" label="采购名称">
          <template slot-scope="scope">
            <span>{{ scope.row.orderName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="采购单编号">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="date" label="采购金额">
          <template slot-scope="scope">
            <span>{{ scope.row }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="date" label="申请人">
          <template slot-scope="scope">
            <span>{{ scope.row.createBy }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="申请时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '0'">待处理</span>
            <span v-if="scope.row.status == '1'">处理中</span>
            <span v-if="scope.row.status == '2'" style="color: green;">已通过</span>
            <span v-if="scope.row.status == '3'" style="color: red;">不通过</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作" v-if="type == 1">
          <template slot-scope="scope">
            <el-button type="text" @click="check(scope.row)">去审核</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="date" label="操作" v-if="type == 2">
          <template slot-scope="scope">
            <el-button type="text" @click="look(scope.row)">查看</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="1"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

      <el-dialog :title="title" :visible.sync="checkDialog" width="70%">

        <div class="box">
          <el-table :data="dialogTableData" border style="width: 100%">
            <el-table-column prop="date" label="采购名称">
              <template slot-scope="scope">
                <span>{{ scope.row.productName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="品牌">
              <template slot-scope="scope">
                <span>{{ scope.row.brand }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="date" label="供应商名称">
              <template slot-scope="scope">
                <span>{{ scope.row.manufacturer }}</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="date" label="单价/元">
              <template slot-scope="scope">

              </template>
            </el-table-column>
            <el-table-column prop="date" label="单位">
              <template slot-scope="scope">

              </template>
            </el-table-column> -->
            <el-table-column prop="date" label="数量">
              <template slot-scope="scope">
                <span>{{ scope.row.productCount }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="date" label="备注">
              <template slot-scope="scope">
                <span>{{ scope.row.productRemark }}</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="date" label="资质">
              <template slot-scope="scope">
                <span>{{ scope.row.materialQualification }}</span>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="request">
            <span style="margin-right: 3vw;">是否满足招标文件要求？</span>
            <el-radio v-model="radio" label="1">满足</el-radio>
            <el-radio v-model="radio" label="2">不满足并退回</el-radio>
          </div>
          <div class="reason">
            <div style="width: 8vw;text-align: left">退回原因？</div>
            <el-input type="textarea" placeholder="请输入退回原因" :rows="5" v-model="remark"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="checkDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
    </div>

  </div>
</template>

<script>
  import base from '../../../untils/base'
  import util from '../../../untils/util'
  import myHttp from '../../../untils/port'
  export default {
    data() {
      return {
        projectName: '',
        isShow: false,
        id: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        type: 1,
        radio: '',
        checkDialog: false,
        tableData: [],
        dialogTableData: [],
        search: {
          orderName: ''
        },
        title: '',
        remark: ''
      }
    },
    mounted() {
      this.getData()
      this.getName()
    },
    methods: {
      //获取项目名称
      getName() {
        myHttp.getGroupListByUserId({
          userId: util.session.get('user').id,
          userType: 4
        }).then(resp => {
          console.log(resp);
          if(resp.data.code == '200'){
            let list = []
            list = resp.data.data.projectList
            let groupId = util.session.get('groupId')
            list.forEach(item => {
              if(item.groupId == groupId){
                this.projectName = item.alias
              }
            })
          }
        })
      },
      // 待审核
      getData() {
        myHttp
          .waitMySolveList({
            projectId: util.session.get('groupId'),
            orderName: this.search.orderName,
            orderType: 'cc_sp',
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          })
          .then((resp) => {
            console.log(resp)
            if (resp.data.code == '200') {
              this.tableData = resp.data.data.list
              console.log(this.tableData);
              this.total = resp.data.data.total
            }
          })
      },
      // 已审核
      getData2() {
        myHttp
          .alreadyMySolveList({
            projectId: util.session.get('groupId'),
            orderName: this.search.orderName,
            orderType: 'cc_sp',
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          })
          .then((resp) => {
            console.log(resp)
            if (resp.data.code == '200') {
              this.tableData = resp.data.data.list || []
              this.total = resp.data.data.total
            }
          })
      },
      //查询
      select(){
        if(this.type == '1'){
          this.pageNum = 1
          this.pageSize = 10
          this.getData()
        }
        if(this.type == '2'){
          this.pageNum = 1
          this.pageSize = 10
          this.getData2()
        }
      },
      // 查看
      look(row){
        this.checkDialog = true
        this.dialogTableData = []
        this.radio = ''
        this.id = row.id
        myHttp.getSpotCheckRecorddetail({
          projectId: util.session.get('groupId'),
          id: row.id
        }).then(resp => {
          console.log(resp);
          if(resp.data.code == '200'){
            this.dialogTableData = resp.data.data.plannedPurchaseDetailList || []
            let status = resp.data.data.status
            if(status == '2'){
              this.radio = '1'
            }
            if(status == '3'){
              this.radio = '2'
            }
          }
        })
      },

      //  提交审核
      submitForm(){
        console.log(this.dialogTableData);
        // let id = ''
        // this.dialogTableData.forEach(item => {
        //   id = id + ',' + item.detailId
        // })
        // id = id.slice(1)
        myHttp.checkOrder({
          id: this.id,
          checkStatus: this.radio,
          remark: this.remark
        }).then(resp => {
          console.log(resp);
          if(resp.data.code == '200'){
            this.$message.success('审核成功')
            this.checkDialog = false
            this.getData()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      switchType(type) {
        this.type = type
        if (type == '1') {
          this.pageNum = 1
          this.pageSize = 10
          this.getData()
        }
        if (type == '2') {
          this.pageNum = 1
          this.pageSize = 10
          this.getData2()
        }
      },
      check(row) {
        this.checkDialog = true
        this.id = row.id
        this.radio = ''
        this.remark = ''
        myHttp.detailPlannedPurchase({
          id: row.id
        }).then(resp => {
          console.log(resp);
          if(resp.data.code == '200'){
            this.dialogTableData = resp.data.data.plannedPurchaseDetailList
          }
        })
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + 1 + index
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        this.pageSize = val
        if (this.type == '1') {
          this.getData()
        }
        if (this.type == '2') {
          this.getData2()
        }
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`)
        this.pageNum = val
        if (this.type == '1') {
          this.getData()
        }
        if (this.type == '2') {
          this.getData2()
        }
      },
    },
  }
</script>

<style scoped>
  @import '../../../assets/css/common.css';

  .container {
    height: 96%;
    padding: 0 1vw;
    background-color: #fff;
  }

  .header {
    display: flex;
    border-bottom: 4px solid #f5f5f5;
  }

  .purchase {
    padding: 2vh 2vw;
    cursor: pointer;
  }

  .active {
    color: #003D9C;
    border-bottom: 4px solid #003D9C;
  }

  .search {
    margin: 2vh 0;
  }

  .container>>>.el-dialog__header {
    text-align: left;
    font-weight: 900;
  }

  .request {
    margin-top: 4vh;
    text-align: left;
  }

  .reason {
    margin-top: 4vh;
    display: flex;
  }
</style>